import { Color } from './color.constants';

export class InfographicBoxType {
    public static readonly Currency = 'currency';
    public static readonly Date = 'date';
    public static readonly Days = 'days';
    public static readonly Percent = 'percent';
}

export class InfographicBox {
    public static readonly TargetClosingDate = 'TargetClosingDate';
    public static readonly TargetInitialFundingAmount = 'TargetInitialFundingAmount';
    public static readonly RevenueOverArRatio = 'RevenueOverArRatio';
    public static readonly SalesLast12Months = 'SalesLast12Months';
    public static readonly PayoffAmount = 'PayoffAmount';
    public static readonly OveradvanceAmount = 'OveradvanceAmount';
    public static readonly MedianDaysToFund = 'MedianDaysToFund';
    public static readonly FundedOpportunitiesCount = 'FundedOpportunitiesCount';
    public static readonly ConversionRate = 'ConversionRate';
    public static readonly ActiveOpportunitiesCount = 'ActiveOpportunitiesCount';
}

export class InfographicBoxData {
    public static TargetClosingDate = {
        title: 'Target Closing Date',
        icon: 'fal fa-handshake',
        type: InfographicBoxType.Date,
        color: Color.Blue
    };
    public static TargetInitialFundingAmount = {
        title: 'Target Initial Funding',
        icon: 'fal fa-bullseye',
        type: InfographicBoxType.Currency,
        color: Color.Green
    };
    public static RevenueOverArRatio = {
        title: '$Rev / $AR',
        icon: 'fal fa-chart-line',
        type: InfographicBoxType.Percent,
        color: Color.Purple
    };
    public static SalesLast12Months = {
        title: 'Last 12 Mon. Sales',
        icon: 'fal fa-calendar-alt',
        type: InfographicBoxType.Currency,
        color: Color.Teal
    };
    public static PayoffAmount = {
        title: 'Payoff Amount',
        icon: 'fal fa-piggy-bank',
        type: InfographicBoxType.Currency,
        color: Color.Red
    };
    public static OveradvanceAmount = {
        title: 'Overadvance Amount',
        icon: 'fal fa-person-carry',
        type: InfographicBoxType.Currency,
        color: Color.Cyan
    };
    public static MedianDaysToFund = {
        title: 'Median Days to Fund',
        multipleMetrics: true,
        icon: 'fal fa-chart-line',
        type: InfographicBoxType.Days,
        color: Color.Orange
    };
    public static FundedOpportunitiesCount = {
        title: 'Count of Funded Opportunities ',
        multipleMetrics: true,
        icon: 'fal fa-box-usd',
        color: Color.Green
    };
    public static ConversionRate = {
        title: 'Conversion Rate',
        multipleMetrics: true,
        icon: 'fal fa-balance-scale',
        type: InfographicBoxType.Percent,
        color: Color.Pink
    };
    public static ActiveOpportunitiesCount = {
        title: 'Count of Active Opportunities',
        multipleMetrics: true,
        icon: 'fal fa-file-invoice-dollar',
        color: Color.Purple
    };
}
